<template>
  <div>
    <h2 class="hotelH2">アクセス</h2>
    <p class="hotelLeadText">{{ address }}</p>
    <div class="hotelMapBox">
      <dl class="hotelMapBoxItem">
        <dt>
          <tk-icon name="train" class="icoTrain"></tk-icon>
          鉄道駅から
        </dt>
        <dd>
          {{ trainAccess || noInforMessage }}
        </dd>
      </dl>
      <dl class="hotelMapBoxItem">
        <dt>
          <tk-icon name="plane" class="icoPlane"></tk-icon>
          空港から
        </dt>
        <dd>{{ airportAccess || noInforMessage }}</dd>
      </dl>
      <dl class="hotelMapBoxItem">
        <dt>
          <tk-icon name="ship" class="icoShip"></tk-icon>
          港から
        </dt>
        <dd>{{ harborAccess || noInforMessage }}</dd>
      </dl>
      <dl class="hotelMapBoxItem">
        <dt>
          <tk-icon name="car" class="icoCar"></tk-icon>
          高速道路のICから
        </dt>
        <dd>
          {{ highwayAccess || noInforMessage }}
        </dd>
      </dl>
    </div>

    <div class="hotelMapBox">
      <dl class="hotelMapBoxItem">
        <dt>
          <tk-icon name="parking" class="icoParking"></tk-icon>
          駐車場について
        </dt>
        <dd v-if="parkingAmenities && parkingAmenities.length">
          <p v-for="amenity in parkingAmenities" :key="amenity.code">
            ・{{ amenity.name }} <br />
          </p>
        </dd>
        <dd v-else>なし</dd>
      </dl>
      <dl class="hotelMapBoxItem">
        <dt>
          <tk-icon name="shuttle" class="icoShuttle"></tk-icon>
          送迎サービスについて
        </dt>
        <dd v-if="pickupAmenities && pickupAmenities.length">
          <p v-for="amenity in pickupAmenities" :key="amenity.code">
            ・{{ amenity.name }} <br />
          </p>
        </dd>
        <dd v-else>なし</dd>
      </dl>
    </div>
  </div>
</template>

<script>
import TkIcon from '../../atoms/TkIcon/TkIcon'

export default {
  name: 'TkHotelAccessInfo',
  components: { TkIcon },
  props: {
    address: {
      type: String,
      required: true,
    },
    trainAccess: {
      type: String,
      default: '',
    },
    airportAccess: {
      type: String,
      default: '',
    },
    harborAccess: {
      type: String,
      default: '',
    },
    highwayAccess: {
      type: String,
      default: '',
    },
    parkingAmenities: {
      type: Array,
      default: () => [],
    },
    pickupAmenities: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      noInforMessage: '情報なし',
    }
  },
}
</script>

<style lang="scss">
@import '@ota-frontend/ui/src/scss/components/HotelCommon.scss';
.icoParking,
.icoPlane,
.icoShuttle,
.icoCar,
.icoTrain,
.icoShip {
  width: auto;
  height: 25px;
  @include media(sp) {
    width: 60px;
    height: 20px;
  }
}
</style>
